import { EmployerDto } from '@zorro/clients';
import { RichTextViewer } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';

import { getEnrollmentInstructionsContent } from './enrollmentInstructions.utils';

type EnrollmentInstructionsViewerProps = {
  content?: string;
  employerId?: EmployerDto['id'];
};

export const EnrollmentInstructionsViewer = ({
  content,
  employerId,
}: EnrollmentInstructionsViewerProps) => {
  const { data: enrollmentInstructions } = useMonolithQuery({
    method: 'enrollmentInstructionsControllerFind',
    params: employerId && [employerId],
  });

  const safeContent = getEnrollmentInstructionsContent(
    content || enrollmentInstructions?.content
  );

  if (!safeContent) {
    return null;
  }

  return <RichTextViewer content={safeContent} />;
};
